module.exports = ".container-content {\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n  .container-content ba-checkbox {\n    width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/components/baMultiCheckbox/baMultiCheckbox.scss
// module id = ./src/app/theme/components/baMultiCheckbox/baMultiCheckbox.scss
// module chunks = main